export const LS_COUNTRY_KEY = 'country';
export const LS_LANGUAGE_KEY = 'language';

export function persistMarketPreference(country?: string | null, language?: string | null): void {
  if (country) {
    localStorage.setItem(LS_COUNTRY_KEY, country.toUpperCase());
  }
  if (language) {
    localStorage.setItem(LS_LANGUAGE_KEY, language.toLowerCase());
  }
}
